import React from 'react'
import { formatInBrazilianDatetime, isDate } from 'utils/functions'

import styles from './styles'

function DisplayTermsAgreement(props) {
  const { questionData } = props
  const classes = styles()

  const buildTermsAgreement = (questionInfo) => {
    const { answer, has_answer } = questionInfo
    return (
      <div className={classes.answersContainer}>
        {has_answer ? (
          <React.Fragment>
            <p>
              <span>
                Concorda com os termos de adesão ao programa de parceiros da XP
                Inc:{' '}
              </span>
              {answer.agreed ? 'sim' : 'não'}
            </p>
            {answer.agreed ? (
              <p>
                <span>Concordou com os termos em: </span>
                {isDate(answer?.terms_accepted_at)
                  ? formatInBrazilianDatetime(answer.terms_accepted_at)
                  : 'N/A'}
              </p>
            ) : null}
          </React.Fragment>
        ) : (
          <p>A questão ainda não foi respondida</p>
        )}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Termos de adesão:</h3>
      {buildTermsAgreement(questionData)}
    </div>
  )
}

export default DisplayTermsAgreement
